export const API_URL = process.env.API_URL || "http://localhost:4000/api";
